module.exports = __webpack_public_path__ + "static/img/company_history_renwu1980.7fe738ef.jpg";